<template>
    <div class="instance">QR Codes</div>
</template>

<script>
export default {};
</script>

<style scoped>
.instance {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Montserrat;
    font-size: 60px;
    font-style: normal;
    font-weight: 700;
    height: 100%;
    line-height: 121.667%; /* 73px */
    letter-spacing: 4.8px;
    text-transform: uppercase;
    opacity: 0.5;
}
</style>
